(() => {
  'use strict';

  const ROOT_SELECTOR = '.nut-pdp-section';

  const numberOrNull = (value) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  };

  const getThemeLimit = (root) => {
    const main = root.querySelector('.nut-pdp-main[data-nut-quantity-limit]');
    return numberOrNull(main?.dataset.nutQuantityLimit) || 6;
  };

  const getVariantLimit = (variant) => {
    if (!variant) return null;
    const limits = [];
    const ruleMax = numberOrNull(variant.quantity_rule?.max);
    if (ruleMax) limits.push(ruleMax);
    if (
      variant.inventory_management === 'shopify' &&
      variant.inventory_policy !== 'continue'
    ) {
      const inventory = numberOrNull(variant.inventory_quantity);
      if (inventory) limits.push(inventory);
    }
    return limits.length ? Math.min(...limits) : null;
  };

  const refreshWrapper = (input) => {
    const wrapper = input.closest('hdt-quantity-wrapp');
    if (!wrapper) return;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const applyLimit = (root, variant = null) => {
    const themeLimit = getThemeLimit(root);
    const variantLimit = getVariantLimit(variant);

    root.querySelectorAll('hdt-quantity-wrapp input[name="quantity"]').forEach((input) => {
      let max = themeLimit;

      if (variantLimit) {
        max = Math.min(max, variantLimit);
      } else {
        const currentMax = numberOrNull(input.max);
        if (currentMax) max = Math.min(max, currentMax);
      }

      const min = numberOrNull(input.min) || 1;
      max = Math.max(min, max);

      input.dataset.nutThemeMax = String(themeLimit);
      input.max = String(max);
      input.dataset.max = String(max);

      const value = numberOrNull(input.value) || min;
      if (value > max) input.value = String(max);
      if (value < min) input.value = String(min);

      const wrapper = input.closest('hdt-quantity-wrapp');
      const plus = wrapper?.querySelector('button[name="plus"]');
      if (plus) {
        const atLimit = (numberOrNull(input.value) || min) >= max;
        plus.disabled = atLimit;
        plus.setAttribute('aria-disabled', atLimit ? 'true' : 'false');
        plus.classList.toggle('disabled', atLimit);
      }

      refreshWrapper(input);
    });
  };

  const initRoot = (root) => {
    if (!root || root.dataset.nutQuantityLimitReady === 'true') return;
    root.dataset.nutQuantityLimitReady = 'true';
    applyLimit(root);
  };

  const init = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  };

  const reapplyAfterVariantChange = (event) => {
    const root = event.target?.closest?.(ROOT_SELECTOR) || document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    window.setTimeout(() => applyLimit(root, event.detail?.variant || null), 0);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('variant:change', reapplyAfterVariantChange);
  document.addEventListener('variant:update', reapplyAfterVariantChange);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
